@if (state.showSpinner) {
  <div class="spinner-wrap">
    <rt-spinner variant="small"></rt-spinner>
  </div>
}

@if (!state.showSpinner) {
  <div>
    <rt-icon name="check" size="medium"> </rt-icon>
    <rt-icon name="dot" size="small-x"> </rt-icon>
  </div>
}
